import { IFormItem } from '@components/Form/FormItem/FormItem';

import { Dictionaries } from '@/api/dictionaries/types';
import { OrganizationShort } from '@/api/organizations/types';
import {
  IndividualSexLabel,
  IndividualStatus,
  IndividualStatusLabel,
} from '@/shared/vaccination/enums';
import { dictToOptions, enumToOptions } from '@/utils/utils';

export const cardSchema = (
  dictionaries?: Dictionaries,
  organizations?: OrganizationShort[],
  structurals?: OrganizationShort[],
  linkLocation?: string,
): IFormItem[] => [
  {
    label: 'Инвентарный номер',
    key: 'inventoryNumber',
    type: 'text',
  },
  {
    label: 'Инвентарный номер матки',
    key: 'uterusInventoryNumber',
    type: 'text',
  },
  {
    label: 'Статус',
    key: 'individualStatus',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualStatusLabel),
    },
  },
  {
    label: 'Заболевание',
    key: 'diseaseDescription',
    type: 'textarea',
    hidden: (form) => form.getFieldValue('individualStatus') !== IndividualStatus.SICK,
    payload: {
      autoSize: true,
    },
  },
  {
    label: 'Дата рождения',
    key: 'birthDate',
    type: 'date',
  },
  {
    label: 'Дата внесения',
    key: 'createdAt',
    type: 'date',
  },
  {
    label: 'Вид животного',
    key: 'animalSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
  },
  {
    label: 'Пол',
    key: 'sex',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualSexLabel),
    },
  },
  {
    label: 'Животная масса (кг)',
    key: 'liveWeight',
    type: 'number',
    split: true,
  },
  {
    label: 'Хозяйство',
    key: 'organizationId',
    type: 'select',
    payload: {
      options: organizations?.map((item) => ({
        label: item.shortName,
        value: item.id,
      })),
    },
  },
  {
    label: 'Структурное подразделение',
    key: 'structuralDivisionId',
    type: 'select',
    payload: {
      options:
        structurals?.map((item) => ({
          label: item.name,
          value: item.id,
        })) || [],
    },
  },
  {
    label: 'Объект',
    key: 'individualLocationId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.INDIVIDUAL_LOCATION),
    },
  },
  {
    label: 'Местонахождение',
    key: 'facilityName',
    type: 'navigate',
    payload: {
      link: linkLocation,
    },
  },
  {
    label: 'Автор создания',
    key: 'createdByName',
    type: 'text',
  },
  {
    label: 'Дата создания',
    key: 'createdAt',
    type: 'date',
  },
  {
    label: 'Автор обновления',
    key: 'updatedByName',
    type: 'text',
  },
  {
    label: 'Дата обновления',
    key: 'updatedAt',
    type: 'date',
  },
];
